<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 16a1 1 0 001-1V4a1 1 0 00-1-1 1 1 0 00-1 1v11a1 1 0 001 1z"/><path d="M21.84 6.52a1 1 0 00-1 1.75A10 10 0 0116 27a10 10 0 01-4.92-18.7 1 1 0 10-1-1.73A12 12 0 0016 29h.05A12 12 0 0028 17a12 12 0 00-6.16-10.48z"/></svg>